export enum AppStates {
    DEFAULT,
    LOGIN,
    PROJECT_DASHBOARD,
    PROCESS_DETAILS,
    ROLES_PAGE,
    USER_PROFILE,
    TEMPLATES_PAGE,
    PROJECTS_PAGE
}